import React from "react";
import type { KgUsersIconProps } from "./KgUsersIcon.types";

/** Multi-user icon for Shared with rows (Figma `users-2`, 16px). */
export const KgUsersIcon: React.FC<KgUsersIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M9.33325 12.668C9.33325 11.6071 8.91182 10.5897 8.16168 9.83954C7.41153 9.0894 6.39412 8.66797 5.33325 8.66797C4.27239 8.66797 3.25497 9.0894 2.50482 9.83954C1.75468 10.5897 1.33325 11.6071 1.33325 12.668"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33341 8.66536C6.80617 8.66536 8.00008 7.47146 8.00008 5.9987C8.00008 4.52594 6.80617 3.33203 5.33341 3.33203C3.86066 3.33203 2.66675 4.52594 2.66675 5.9987C2.66675 7.47146 3.86066 8.66536 5.33341 8.66536Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 12.6654C14.6667 11.6045 14.2453 10.5871 13.4952 9.83694C12.745 9.08679 11.7276 8.66536 10.6667 8.66536C11.374 8.66536 12.0523 8.38441 12.5524 7.88432C13.0525 7.38422 13.3334 6.70594 13.3334 5.9987C13.3334 5.29145 13.0525 4.61318 12.5524 4.11308C12.0523 3.61298 11.374 3.33203 10.6667 3.33203"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgUsersIcon;
